/* eslint-disable no-undef */
import { AdManager } from './adManager';

const props = [ ];

export const DisplayAdManagerDirective = reactDirective => reactDirective(AdManager, props);
DisplayAdManagerDirective.$inject = ['reactDirective'];

angular
    .module('WB.App')
    .directive('displayAdManager', DisplayAdManagerDirective);